import classNames from "classnames";
import icons_svg from "../images/icons.svg";

const Icon = ({ name, className = "", style, alt, id }) => {
  return (
    <svg className={classNames("icon", className)} style={style} alt={alt}>
      <use href={icons_svg + "#" + name} id={id}></use>
    </svg>
  );
};

export default Icon;
